module.exports = __webpack_public_path__ + "media/assets/logo-0dc570c9821ece8ce738d2853e684244.svg";